import { RequestService } from '../../../../common/services/RequestService';
import { UPDATE_PROFILE_FILTERS, GET_PROFILE_FILTERS } from '../constants';
import { dataAdjustmentProfileResponse } from './dataAdjustment';

export const updateProfileFiltersRequest = async (profileId, filters) => {
  let response = await RequestService.put(UPDATE_PROFILE_FILTERS, {
    profile_id: profileId,
    filters,
  });
  // todo добавить после успешного запроса в entityTypeId entityTypeKey и потом можно убрать лишний запрос
  response = await RequestService.get(
    GET_PROFILE_FILTERS.replace('{profile_id}', profileId)
  );
  return response && dataAdjustmentProfileResponse(response.data);
};
